"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = exports.ApiResponseCodes = exports.EnvironmentTypes = void 0;
var EnvironmentTypes;

(function (EnvironmentTypes) {
  EnvironmentTypes["DEVELOPMENT"] = "development";
  EnvironmentTypes["STAGING"] = "staging";
  EnvironmentTypes["ONBOARDING"] = "onboarding";
  EnvironmentTypes["PRODUCTION"] = "production";
  EnvironmentTypes["AMPLIFY_APP"] = "amplifyapp";
  EnvironmentTypes["LOCAL"] = "local";
})(EnvironmentTypes || (exports.EnvironmentTypes = EnvironmentTypes = {}));

var ApiResponseCodes;

(function (ApiResponseCodes) {
  ApiResponseCodes[ApiResponseCodes["unauthorized"] = 403] = "unauthorized";
})(ApiResponseCodes || (exports.ApiResponseCodes = ApiResponseCodes = {}));

var Region;

(function (Region) {
  Region["DEU"] = "deu";
  Region["GBR"] = "gbr";
})(Region || (exports.Region = Region = {}));